export var IHotkeyTypes;
(function (IHotkeyTypes) {
    IHotkeyTypes["addBoxEntity"] = "b";
    IHotkeyTypes["removeEntities"] = "Delete";
    IHotkeyTypes["removeEntitiesAlt"] = "Backspace";
    IHotkeyTypes["propScale"] = "Shift";
    IHotkeyTypes["allSidesScale"] = "Alt";
    IHotkeyTypes["groupSelect"] = "Shift";
    IHotkeyTypes["individualGroupRotation"] = "r";
    IHotkeyTypes["individualGroupScale"] = "s";
    IHotkeyTypes["meta"] = "Meta";
    IHotkeyTypes["copy"] = "c";
    IHotkeyTypes["paste"] = "v";
})(IHotkeyTypes || (IHotkeyTypes = {}));
export const hotkeyIsPressed = (selectedKeys, hotkeys) => {
    return selectedKeys.includes(hotkeys[0]);
};
